<template>
    <div class="relative z-40">
        <div>
            <div class="relative z-40">
                <div>
                  <input
                    v-model="inputData"
                    @input="upperCase"
                    @focus="option = true"
                    @blur="onBlur"
                    :placeholder="placeholder"
                    type="text"
                    :disabled="text"
                    class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none"
                  />
                </div>
                <!-- {{ suggestion }} -->
                <div v-if="text" class="absolute top-2.5 right-3">
                  <div class="bg-[#006A00] rounded-full text-sm w-6 h-6 font-medium text-white flex items-center justify-center hover:bg-[#006a00a1]" @click="removeEmpKEy">
                      <p>X</p>
                  </div>
                </div>
                <!-- Dropdown list -->
                <div v-show="option && filteredOptions.length" class="absolute w-full bg-white border rounded-md mt-1 shadow-lg z-10">
                  <div
                    v-for="(option, index) in filteredOptions"
                    :key="index"
                    class="py-3 px-3 text-sm hover:bg-[#e9e9e9] text-[#6d6b6b] border-b border-gray-200"
                    @click="getValue(option.key, option.value)">
                    {{ option.value }}
                  </div>
                </div>
              </div>
        </div>
    </div>
  </template>
  
  <script>
  import { defineComponent } from 'vue'
  
  export default defineComponent({
    data() {
      return {
        option: false,  // For showing/hiding the options
        inputData: "",  // The input value
        placeholder: "Type to Search Employee",
        text: false,
      }
    },
    props:{
        suggestions:{
            type: Array,
            default:()=>[
            { key: "TEST1", value: "LHAN ZELL OBLIDA REYES" },
            { key: "TEST2", value: "LEBRON JAMES" },]
        }
    },
    computed: {
      // Filter suggestions based on the input data
      filteredOptions() {
        if(this.suggestions.length){
         return this.suggestions
            .filter(suggestion => {
              const key = suggestion.key?.toString().toLowerCase() || "";
              const value = suggestion.value?.toString().toLowerCase() || "";
              const input = this.inputData?.toLowerCase() || "";
              return key.includes(input) || value.includes(input);
            })
            .slice(0, 5);
        }
        else{
            return null;
        }
      
      }
    },
    methods: {
      onBlur() {
        setTimeout(() => {
          this.option = false;
        }, 200);  
      },
      upperCase(){
        this.inputData = this.inputData.toUpperCase()
      },
      removeEmpKEy(){
        this.inputData = ""
        this.text = false
        this.$emit("getEmpKey", "NA" , "NA")
      },
      getValue(key,value) {
        this.inputData = value;  // Update the input field with the selected option
        this.option = false;  // Hide the dropdown after selection
        this.text = true
        this.$emit("getEmpKey", key , value)
    
      }
    },
  })
  </script>
  